import { render, staticRenderFns } from "./AccidentClassificationEdit.vue?vue&type=template&id=a31157c2"
import script from "./AccidentClassificationEdit.vue?vue&type=script&lang=js"
export * from "./AccidentClassificationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports